import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import {
  Alert, CircularProgress, Box, Typography,
} from '@mui/material';
import { observer } from 'mobx-react';

import { useCampaignFailedMsgs, FAILED_MSGS_LIMIT } from '../../hooks/useCampaignFailedMsgs';
import texts from '../../texts.json';

import {
  Eyebrow,
  FailedList,
  FailedRow,
} from './styles';

const { details } = texts.history;

const FailedPanel = ({ campaignId, totalFailed }) => {
  const { docs, loading, error } = useCampaignFailedMsgs(campaignId);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">{details.failed.error}</Alert>;
  }

  if (docs.length === 0) {
    return <Alert severity="info">{details.failed.empty}</Alert>;
  }

  const hasGap = totalFailed > docs.length;
  const noticeText = docs.length >= FAILED_MSGS_LIMIT
    ? format(details.failed.truncatedNotice, { limit: FAILED_MSGS_LIMIT, total: totalFailed })
    : details.failed.partialSyncNotice;

  return (
    <>
      <Eyebrow>{`${details.failed.heading} (${docs.length})`}</Eyebrow>
      {hasGap && (
        <Alert severity="info" variant="outlined" sx={{ mb: 1.5 }}>
          {noticeText}
        </Alert>
      )}
      <FailedList>
        {docs.map((doc) => (
          <FailedRow key={doc.id}>
            <Typography component="span" variant="body2">
              {doc.data.phoneNumber || details.failed.unknownPhone}
            </Typography>
            <Typography component="span" variant="body2" color="text.secondary">
              {doc.data.lastError || details.failed.unknownReason}
            </Typography>
          </FailedRow>
        ))}
      </FailedList>
    </>
  );
};

FailedPanel.propTypes = {
  campaignId: PropTypes.string.isRequired,
  totalFailed: PropTypes.number,
};

FailedPanel.defaultProps = {
  totalFailed: 0,
};

export default observer(FailedPanel);
